import banner from '../../../assets/industries/fintech.webp'

import tick from '../../../assets/industries/tick.webp'


export const bannerData = {
    title1: 'Financial Software',
    title2: 'Development Services',
    desc: 'CodeZone helps global fintech companies to transform their financial services with emerging technology.',
    img: banner,
    btnTitle: 'Hire Fintech Software Developers'
}

export const hireData = {
    img: tick,
    title: 'Hire Fintech Application',
    points: [
        'Diverse technology stack',
        'Profound knowledge of the Fintech industry',
        'Flexible engagement models',
        'Dedicated project management',
        'Commitment to agile best practices',
        'Secure solution development for financial services',
        'Vast experience in AI, Big Data, Blockchain'

    ]
}

export const webDesignData = {
    title1: 'From Ideation to Deployment,We Offer Multiple',
    title1Span: 'Fintech Software',
    title2: 'Development Services',
    cards: [
        {
            title: 'Custom Fintech Software',
            desc: 'Hire fintech software developers with expertise in developing custom fintech software solutions for both web and mobile platforms to enhance user experience and stay ahead of the curve.',
        },
        {
            title: 'Digital Payment Solutions',
            desc: 'Create digital payment solutions that bring you financial services into the digital world. From payment gateway development to digital mobile wallet apps and online banking applications, we provide expert software developers with expertise in multiple technologies.',
        },
        {
            title: 'Intelligent CRM Solution',
            desc: 'Hire fintech software developers with expertise in developing cloud-based CRM solutions integrated with the latest technologies, including microservices and artificial intelligence for better financial management.',
        },
        {
            title: 'AI-enabled Fintech Apps',
            desc: 'We understand the potential of AI and Big Data in fintech app development. Our AI and Big Data engineers can help you in smart decision making to improve customer engagement. Hire fintech software development experts.',
        },

    ]
}